import React from "react";

export default function StepHeader({ eyebrow, title, subtitle, done }) {
  return (
    <div>
      <div className="text-[9px] font-bold tracking-[0.12em] uppercase text-[var(--gray3)] mb-1.5">
        {eyebrow}
      </div>
      <div className="text-[18px] font-bold tracking-[-0.4px] text-[var(--ink)] flex items-center gap-2">
        {title}
        {done ? (
          <span className="text-[9px] font-bold px-2 py-0.5 rounded-[10px] bg-[rgba(52,199,89,.13)] text-[var(--green-deep)] border border-[rgba(52,199,89,.3)] tracking-[.04em]">
            DONE
          </span>
        ) : null}
      </div>
      {subtitle ? (
        <div className="text-[12px] text-[var(--gray2)] mt-1.5 max-w-[600px] leading-[1.55]">
          {subtitle}
        </div>
      ) : null}
    </div>
  );
}
